import { GenericTable } from "../../components/table/GenericTable";
import { RemoteFileInfo } from "../../types/types";
import { GridApiCommunity } from "@mui/x-data-grid/internals";
import { GridColDef } from "@mui/x-data-grid";

export default function FileInfoTable(props: {
  searchText: string;
  directoryInfo: RemoteFileInfo[];
  apiRef:React.MutableRefObject<GridApiCommunity>;
  fileFilterColumnsConfig:GridColDef[];
}) {
  
  let fileInfo = props.directoryInfo
    .filter((fileInfo: RemoteFileInfo) => fileInfo.name.startsWith(props.searchText))
    .map((fileInfo: RemoteFileInfo) => ({
      ...fileInfo,
      lastmodified: new Date(fileInfo.lastmodified).toISOString().split("T").join(" ").substring(0, 19),
      id: fileInfo.name,
    }));

  return (
    <GenericTable
      disableColumnFilter
      // disableColumnMenu
      // disableColumnSelector
      disableRowSelectionOnClick
      density="compact"
      autoHeight
      sx={{
        boxShadow: 1,
        padding: 1,
        borderRadius: 1,
      }}

      rows={fileInfo}
      columns={props.fileFilterColumnsConfig}

      
      pageSizeOptions={[5, 10, 20, 50, 100]}
      initialState={{
        sorting: {
          sortModel: [{ field: "lastmodified", sort: "desc" }],
        },
        pagination: {
          paginationModel:{
            pageSize: 5,
          }
        },
      }}
      apiRef={props.apiRef}
      // hideFooterSelectedRowCount
    />
  );
}
